<template>
  <div class="progress-container">
    <div 
      class="progress-bar" 
      :style="{ width: props.progress + '%' }"
    ></div>
    <span class="progress-label">{{ props.progress }}%</span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      required: true,
      validator: (val) => val >= 0 && val <= 100
    }
  },
  setup(props) {
    // no need to return `progress` separately
    return { props }
  }
})
</script>

<style scoped>
.progress-container {
  position: relative;
  width: 100%;
  height: 24px;
  background: var(--background-color);
  border-radius: 12px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, var(--primary-light), var(--primary-color));
  transition: width 0.3s ease;
}

.progress-label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: inherit;
    font-weight: bold;
    line-height: 24px;
    color: var(--white-color);
}
</style>
